import { BaseService } from './BaseService';

export class OrdersService extends BaseService {

  async getReport(branchOfficeId, from, to, paymentType){
    const url = `app/ordersReport?branchOfficeId=${branchOfficeId}&paymentType=${paymentType}&from=${from}&to=${to}`;
    try {
      return this.http(url, 'get', {});
    } catch (error) {
      console.log('ERR ',error);
      return {
        ok: false,
        message: error.message
      };
    }
  }

  async confirmOrderByCompany(companyId, orderId){
		const response = {
			ok: false,
			message: '',
		};
		try {
			const url = `app/companyConfirmOrder`;
			const res = await this.http(url, 'POST', {
        company_id: companyId, 
        order_id: orderId
      });
			
			response.ok = res.ok;
			response.message = res.message;
		} catch (error) {
      console.log('Err confirmOrderByCompany ', error);
			response.message = error.message;
		}
		return response;
  }

  async markOrderAsPaid(companyId, orderId){
		const response = {
			ok: false,
			message: '',
			data: {}
		};
		try {
			const url = `app/orders/mark-as-paid`;
			const res = await this.http(url, 'POST', {
        company_id: companyId, 
        order_id: orderId
      });
			
			response.ok = res.ok;
			response.message = res.message;
			response.data = res.data;
		} catch (error) {
      console.log('Err confirmOrderByCompany ', error);
			response.message = error.message;
		}
		return response;
  }
}